import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import PageHeader from '#common/PageHeader';
import Button from '#common/Button';

import { ProjectLinks, ProjectPreview } from './ProjectTemplate.style';
import SmallProjects from './SmallProjects';

import ProjectTemplate from './ProjectTemplate';

const JsProjectsWrapper = styled.section`
  ${props => props.theme.spacing.sectionBottom};
`;

const JsProjects = () => {
  const jsprojects = useStaticQuery(
    graphql`
      query {
        allJsprojectsJson {
          edges {
            node {
              description
              title
              id
              links {
                youtube

                image
              }
            }
          }
        }
      }
    `
  );

  return (
    <JsProjectsWrapper id="public-speaking">
      <PageHeader style={{ marginBottom: 100 }}>Public Speaking</PageHeader>

      {jsprojects.allJsprojectsJson.edges.map(({ node }) => (
        <ProjectTemplate
          key={node.id}
          title={node.title}
          desc={node.description}
          links={
            <ProjectLinks>
              <Button target="__blank" as="a" href={node.links.youtube}>
                Watch Now!
              </Button>
            </ProjectLinks>
          }
          preview={
            <ProjectPreview>
              <img style={{ width: '80%' }} src={node.links.image} alt="" />
            </ProjectPreview>
          }
        />
      ))}
      <SmallProjects />
    </JsProjectsWrapper>
  );
};

export default JsProjects;
